import propType from 'prop-types';
import React from 'react';
import { PAGING_SETTINGS } from '../../config/constant';
import usePaging from '../../hooks/usePaging';
import { HorizontalArticleCard, VerticalArticleCard } from '../Card';

const ArticlesGrid = ({ category, posts }) => {
  const postsPerPage = PAGING_SETTINGS.POSTS_PER_PAGE;
  const [page, isLastPage, loadMore] = usePaging(
    category,
    posts.length,
    postsPerPage
  );

  return (
    <div className="articles-lists">
      <article className="articles-lists__wrapper">
        {posts.slice(0, postsPerPage * page).map((post, index) => {
          const { title, excerpt, categories, uri, featuredImage } = post;
          if (!((index + 1) % 5 === 0)) {
            return (
              <VerticalArticleCard
                key={post.title}
                title={title}
                categories={categories}
                uri={uri}
                featuredImage={featuredImage}
              />
            );
          }
          return (
            <HorizontalArticleCard
              key={post.title}
              title={title}
              excerpt={excerpt}
              categories={categories}
              uri={uri}
              featuredImage={featuredImage}
            />
          );
        })}
      </article>
      {!isLastPage && (
        <button className="load-more-btn" type="button" onClick={loadMore}>
          LOAD MORE
        </button>
      )}
    </div>
  );
};

ArticlesGrid.propTypes = {
  category: propType.string.isRequired,
  posts: propType.arrayOf(
    propType.shape({
      title: propType.string.isRequired
    })
  ).isRequired
};

export default ArticlesGrid;
